const MONTH_NAMES = [
  'january',
  'february',
  'march',
  'april',
  'may',
  'june',
  'july',
  'august',
  'september',
  'october',
  'november',
  'december'
] as const;

export const EDITION_VIDEOS_FILE_PATH = '/glambox/assets/edition-videos/';

/**
 * Builds a standardized edition asset file name as month-year.ext
 * Example: editionDate 202607 + mp4 → july-2026.mp4
 */
export function buildEditionAssetFileName(
  editionDate: number,
  extension: string
): string {
  if (!editionDate || Number.isNaN(editionDate)) {
    throw new Error('editionDate is required to build the asset file name.');
  }

  const editionDateText = String(editionDate);
  if (!/^\d{6}$/.test(editionDateText)) {
    throw new Error(
      'editionDate must be in YYYYMM format to build the asset file name.'
    );
  }

  const year = editionDateText.slice(0, 4);
  const month = Number(editionDateText.slice(4, 6));
  if (month < 1 || month > 12) {
    throw new Error('editionDate month must be between 01 and 12.');
  }

  const normalizedExtension = extension.replace(/^\./, '').toLowerCase();
  if (!normalizedExtension) {
    throw new Error('extension is required to build the asset file name.');
  }

  return `${MONTH_NAMES[month - 1]}-${year}.${normalizedExtension}`;
}

export function getPosterExtensionFromFile(file: File): 'png' | 'jpg' {
  if (file.type === 'image/png') return 'png';
  if (file.type === 'image/jpeg' || file.type === 'image/jpg') return 'jpg';

  const name = file.name?.toLowerCase() || '';
  if (name.endsWith('.png')) return 'png';
  if (name.endsWith('.jpg') || name.endsWith('.jpeg')) return 'jpg';

  throw new Error('Poster must be png or jpg.');
}
